var configs = {
    breadcrumbs: {
        separator: '/',
        removeFirst: false
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/navbars/_configs.js
// module id = 69
// module chunks = 0